import ReportEntry from './ReportEntry';

export default ReportEntry;
